import {
	PCA_Body,
	PCA_CloseButton,
	PCA_Code,
	PCA_Container,
	PCA_Icon,
	PCA_Text,
	PCA_Title,
	PCA_Value,
} from "./PromoCodeApplied.styled";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { AnimatePresence } from "framer-motion";
import { Check, X } from "lucide-react";
import { useStores } from "../../../stores";

interface PromoCodeAppliedProps {}

export const PromoCodeApplied = observer(({}: PromoCodeAppliedProps) => {
	const { t } = useTranslation();
	const { promoCodeStore } = useStores();

	return (
		<AnimatePresence>
			{promoCodeStore.isActive && (
				<PCA_Container
					initial={{ opacity: 0, y: -12, height: 0 }}
					animate={{ opacity: 1, y: 0, height: "auto" }}
					exit={{ opacity: 0, y: -12, height: 0 }}
					transition={{
						duration: 0.22,
						ease: [0.16, 1, 0.3, 1],
					}}
				>
					<PCA_Body>
						<PCA_Icon>
							<Check size={18} strokeWidth={3} />
						</PCA_Icon>

						<PCA_Text>
							<PCA_Title>{t("pages.pricing.promoCode.appliedTitle")}</PCA_Title>
							<PCA_Value>
								{t("pages.pricing.promoCode.appliedDescription", {
									code: promoCodeStore.promoCode,
									percent: promoCodeStore.discount,
								})}
							</PCA_Value>
						</PCA_Text>

						<PCA_Code>{promoCodeStore.promoCode}</PCA_Code>

						<PCA_CloseButton type="button" onClick={promoCodeStore.clear}>
							<X size={18} />
						</PCA_CloseButton>
					</PCA_Body>
				</PCA_Container>
			)}
		</AnimatePresence>
	);
});
